import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "complete-product-creation"
    }}>{`Complete Product Creation`}</h1>
    <p>{`Now resources, persons, security deposit, locations, attributes, quantity, pricing and features
are controlled by `}<inlineCode parentName="p">{`Inventory tab`}</inlineCode>{` of product page.`}</p>
    <p>{`Suppose you've 3 cars of Audi. Now you don't need to create 3 individual product for
these three cars. You just need to create one product, then from inventory tab attach the
relevant inventory.`}</p>
    <p>{`To successfully create a product you have to follow these two stages.`}</p>
    <h2 {...{
      "id": "first-stage-"
    }}>{`First Stage :`}</h2>
    <p>{`First create an inventory with the `}<inlineCode parentName="p">{`resources`}</inlineCode>{`, `}<inlineCode parentName="p">{`persons`}</inlineCode>{`, `}<inlineCode parentName="p">{`security deposit`}</inlineCode>{`, `}<inlineCode parentName="p">{`locations`}</inlineCode>{`, `}<inlineCode parentName="p">{`attributes`}</inlineCode>{`,
`}<inlineCode parentName="p">{`quantity`}</inlineCode>{`, `}<inlineCode parentName="p">{`pricing`}</inlineCode>{` and `}<inlineCode parentName="p">{`features`}</inlineCode></p>
    <p><img alt="FullInventory.png" src="https://s3.amazonaws.com/redqteam.com/documentation/rnb/images/FullInventory.png" /></p>
    <h2 {...{
      "id": "second-stage-"
    }}>{`Second Stage :`}</h2>
    <p>{`Once you create the inventory with all the pricing, quantity , resource attributes etc. you will
need to create a product and attach the inventory with the product.`}</p>
    <p><img alt="FullProduct.png" src="https://s3.amazonaws.com/redqteam.com/documentation/rnb/images/FullProduct.png" /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      